import React from "react";
import CyberIntelIcon from "./icon";
import CyberIntelBody from "./body";
import "./style.css";

export const CyberIntelBtn = () => {
  return (
    <>
      <CyberIntelIcon />
      <CyberIntelBody />
    </>
  );
};

export default CyberIntelBtn;
